import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Container } from 'reactstrap';

//Routes
import routes from '../routes/views.routes';

//Components
import NavBarEmpty from '../components/Navbars/NavBarEmpty';

export default function Empty() {

    return (
        <div className='content-empty'>
            <div className="img-bg"></div>
            <NavBarEmpty />
            <Container className='mt-3'>
                <Routes>
                    {
                        routes.filter(route => route.layout == "/empty").map((route, key) => {
                            const Screen = route.component;
                            return (
                                <Route
                                    path={route.path}
                                    element={<Screen />}
                                    key={key}
                                />
                            )
                        })
                    }
                </Routes>
            </Container>
        </div>
    )
}